import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { AvailableSubscriptionsResult, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { log } from '@24i/nxg-core-utils/src/logger';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import { useFirebase } from '@24i/nxg-sdk-smartott-shared/src/context/Firebase';
import { useUserQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/user/useUserQuery';

const useEntitledSubscriptionsQuery = (
    options?: UseQueryOptions<AvailableSubscriptionsResult>
): UseQueryResult<AvailableSubscriptionsResult> => {
    const { fetchEntitledSubscriptions } = usePurchaseData();
    const { user } = useUserQuery();
    const { recordError } = useFirebase();

    return useQuery<AvailableSubscriptionsResult>(
        QUERY_KEYS.mySubscriptions,
        () => fetchEntitledSubscriptions(),
        {
            ...options,
            enabled: !!user,
            onError: (error) => {
                log(error);
                recordError?.(error);
                options?.onError?.(error);
            },
        }
    );
};

export default useEntitledSubscriptionsQuery;
